'use strict';

exports.__esModule = true;
exports.parse = parse;

exports.default = function () {
    return function bitmapFontParser(resource, next) {
        // skip if no data or not xml data
        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.XML) {
            next();

            return;
        }

        // skip if not bitmap font data, using some silly duck-typing
        if (resource.data.getElementsByTagName('page').length === 0 || resource.data.getElementsByTagName('info').length === 0 || resource.data.getElementsByTagName('info')[0].getAttribute('face') === null) {
            next();

            return;
        }

        var xmlUrl = !resource.isDataUrl ? path.dirname(resource.url) : '';

        if (resource.isDataUrl) {
            if (xmlUrl === '.') {
                xmlUrl = '';
            }

            if (this.baseUrl && xmlUrl) {
                // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
                if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
                    xmlUrl += '/';
                }
            }
        }

        // remove baseUrl from xmlUrl
        xmlUrl = xmlUrl.replace(this.baseUrl, '');

        // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
        if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
            xmlUrl += '/';
        }

        var pages = resource.data.getElementsByTagName('page');
        var textures = [];
        var loadOptions = {
            crossOrigin: resource.crossOrigin,
            loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
            metadata: resource.metadata.imageMetadata,
            parentResource: resource
        };

        for (var x = 0; x < pages.length; ++x) {
            var textureUrl = xmlUrl + pages[x].getAttribute('file');

            if (_core.utils.TextureCache[textureUrl]) {
                textures.push(_core.utils.TextureCache[textureUrl]);
            } else {
                // load the texture for the font
                this.add(resource.name + '_image' + x, textureUrl, loadOptions, function () {
                    var nextTextures = [];

                    for (var _x = 0; _x < pages.length; ++_x) {
                        var nextTextureUrl = xmlUrl + pages[_x].getAttribute('file');

                        if (_core.utils.TextureCache[nextTextureUrl]) {
                            nextTextures.push(_core.utils.TextureCache[nextTextureUrl]);
                        } else {
                            return;
                        }
                    }
                    parse(resource, nextTextures);
                    next();
                });
            }
        }

        if (textures.length === pages.length) {
            parse(resource, textures);
            next();
        }
    };
};

var _path = require('path');

var path = _interopRequireWildcard(_path);

var _core = require('../core');

var _resourceLoader = require('resource-loader');

var _extras = require('../extras');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Register a BitmapText font from loader resource.
 *
 * @function parseBitmapFontData
 * @memberof PIXI.loaders
 * @param {PIXI.loaders.Resource} resource - Loader resource.
 * @param {PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
 */
function parse(resource, textures) {
    resource.bitmapFont = _extras.BitmapText.registerFont(resource.data, textures);
}
//# sourceMappingURL=bitmapFontParser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pixi.js/lib/loaders/bitmapFontParser.js
// module id = 132
// module chunks = 114276838955818 151087471038741 164721891013254